import React from 'react'
import {Stack,Box,Typography} from '@mui/material'
import logo from '../assets/icons/gym_logo2.png'
const Footer = () => {
  return (
    <Box mt="80px" bgcolor="#FFE4C4">
      <Stack gap="40px" alignItems="center" px="40px" pt="24px">
         <img src={logo} width="600px" height="80px"/>
         <Typography variant="h5" pb="40px" mt="20px">
              Made By <span style={{fontWeight:'1000'}}>Chander Veer Singh</span>
         </Typography>
      </Stack>
    </Box>
  )
}

export default Footer